import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cc-brand-link',
  templateUrl: './brand-link.component.html',
  styleUrl: './brand-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSwitch, NgSwitchCase, NgIf]
})
export class BrandLinkComponent {
  @Input() public url?: string;
  @Input() public claim?: string;
}
